import Input from '@ben/orion/input';
import { Controller, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';

interface IModularTextInputProps {
  componentControllerName: string;
}

const ModularTextInput = ({
  componentControllerName,
}: IModularTextInputProps) => {
  const { control } = useFormContext();
  return (
    <Wrapper>
      <Controller
        control={control}
        name={`${componentControllerName}.maxLength`}
        render={({ field }) => (
          <Input {...field} name="Max length input (optional)" type="number" />
        )}
      />
      <Controller
        control={control}
        name={`${componentControllerName}.default`}
        render={({ field }) => (
          <Input {...field} name="Default value (optional)" />
        )}
      />
    </Wrapper>
  );
};

export default ModularTextInput;

const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
